// extracted by mini-css-extract-plugin
export default {"disableFocusOutline":"XF7MsArAftS8V32N7Q2h"};